import { FileDown, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FR = {
  "Beta-glucans": "Bêta-glucanes", "Beta-glucans (combined)": "Bêta-glucanes (combinés)", "Starch (alpha-glucan)": "Amidon (alpha-glucane)",
  "Polysaccharide-K (PSK)": "Polysaccharide-K (PSK)", Triterpenes: "Triterpènes", Cordycepin: "Cordycépine", Adenosine: "Adénosine",
  Lead: "Plomb", Arsenic: "Arsenic", Cadmium: "Cadmium", Mercury: "Mercure", "E. coli": "E. coli", Salmonella: "Salmonelle",
  "Yeast & mould": "Levures et moisissures", "Pesticide residue": "Résidus de pesticides", "Not detected": "Non détecté",
  Detected: "Détecté", Absent: "Absent", Present: "Présent",
};
const tr = (s, t) => t(s, FR[s] || s);

const Rows = ({ title, rows, testid, t }) => (
  <div className="mt-6" data-testid={testid}>
    <div className="grid grid-cols-[1fr_auto_auto] gap-4 pb-2 border-b border-[#B5A642]/30 text-[10px] uppercase tracking-[0.2em]">
      <span className="text-[#B5A642]">{title}</span>
      <span className="text-[#D3CEC4]/55 w-24 text-right">{t("Result", "Résultat")}</span>
      <span className="text-[#D3CEC4]/55 w-24 text-right hidden sm:block">{t("Spec.", "Norme")}</span>
    </div>
    {rows.map(([name, result, spec]) => (
      <div key={name} className="grid grid-cols-[1fr_auto_auto] gap-4 py-2 border-b border-[#303B2D]/50 text-[12px]">
        <span className="text-[#D3CEC4]/80">{tr(name, t)}</span>
        <span className="text-[#E8DDC7] w-24 text-right">{tr(result, t)}</span>
        <span className="text-[#D3CEC4]/40 w-24 text-right hidden sm:block">{tr(spec, t)}</span>
      </div>
    ))}
  </div>
);

export const LabProof = ({ batchNo, lab, sample, t }) => (
  <div data-testid="lab-proof" className="mt-10 border border-[#303B2D] rounded-sm p-6 bg-[#111A14]/60">
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#B5A642]">{t("Lab proof", "Preuve de laboratoire")}</p>
        <p className="mt-2 font-display text-2xl text-[#E8DDC7] font-light">{t("Tested, and shown in full.", "Testé, et montré en entier.")}</p>
        <p className="mt-1 text-[12px] text-[#D3CEC4]/60">
          {lab.lab_name} · {lab.tested_on} · {lab.certificate_no}
        </p>
      </div>
      <span
        data-testid="lab-verdict"
        className="flex items-center gap-1.5 px-3 py-1.5 border border-[#B5A642]/60 rounded-full text-[10px] uppercase tracking-[0.2em] text-[#B5A642]"
      >
        <Check className="w-3 h-3" /> {lab.verdict === "Passed" ? t("Passed", "Conforme") : lab.verdict}
      </span>
    </div>
    <Rows title={t("Active compounds", "Composés actifs")} rows={lab.actives} testid="lab-actives" t={t} />
    <Rows title={t("Contaminant screening", "Dépistage des contaminants")} rows={lab.screening} testid="lab-screening" t={t} />
    <a
      href={`${API}/ledger/${encodeURIComponent(batchNo)}/certificate`}
      data-testid="lab-certificate-download"
      className="mt-6 inline-flex items-center gap-2 px-6 py-3 border border-[#B5A642]/70 text-[#D3CEC4] text-[11px] uppercase tracking-[0.2em] rounded-sm hover:bg-[#B5A642]/10 transition-colors duration-300"
    >
      {t("Download the certificate", "Télécharger le certificat")} <FileDown className="w-3.5 h-3.5" />
    </a>
    {sample && <p className="mt-3 text-[12px] text-[#D3CEC4]/50">{t("Sample figures for preview, to be replaced by the laboratory's own report.", "Chiffres d'exemple pour l'aperçu, à remplacer par le rapport du laboratoire.")}</p>}
  </div>
);
